import { brandedFabStyles } from './BrandedFab.styles';
import { primaryFabStyles } from './PrimaryFab.styles';
import { secondaryFabStyles } from './SecondaryFab.styles';
import { surfaceFabStyles } from './SurfaceFab.styles';
import { tertiaryFabStyles } from './TertiaryFab.styles';
export const fabVariantStyles = {
    branded: brandedFabStyles,
    primary: primaryFabStyles,
    secondary: secondaryFabStyles,
    surface: surfaceFabStyles,
    tertiary: tertiaryFabStyles,
};
